import React from "react";
import lodash from "lodash";
import { of, BehaviorSubject } from "rxjs";
import {
   debounceTime, distinctUntilChanged,
   switchMap, map, catchError
} from "rxjs/operators";

import { getJobTitleAutoSuggestions } from "../../../../services/suggestions/job";

import renderAutoSuggestWithOptions from "../components/autoSuggest/AutoSuggestHOC";

const getSuggestionValue = (suggestion) => {
   let div = document.createElement("div");
   div.innerHTML = suggestion.searchReplacement;
   return div.textContent;
};

const renderSuggestion = suggestion => (
   <div dangerouslySetInnerHTML={{ __html: suggestion.searchReplacement }} />
);

const reFormatSelection = (val) => {
   return lodash.isPlainObject( val ) ? getSuggestionValue( val ) : lodash.isString(val) ? val : "";
}

const jobTitleSuggestInput$ = new BehaviorSubject("");
const jobTitleSuggestObservable$ = jobTitleSuggestInput$.pipe(
   debounceTime(300),
   distinctUntilChanged(),
   switchMap((input) => {
      if( lodash.isPlainObject( input ) && input.keyword && input.keyword.length > 2 ) {
         return getJobTitleAutoSuggestions(input.keyword).pipe(
            map((data) => {
               return data.suggestions
            }),
            catchError((error) => { console.log(error); return of( [] ) })
         )
      } else {
         return of([])
      }
   })
);

const JobTitleSuggestion = renderAutoSuggestWithOptions(
   jobTitleSuggestObservable$,
   jobTitleSuggestInput$,
   renderSuggestion,
   getSuggestionValue,
   reFormatSelection
);


JobTitleSuggestion.defaultProps = {
   value : ""
};

export default JobTitleSuggestion;
